var _slicedToArray = require("/workspaces/neuler/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var _toConsumableArray = require("/workspaces/neuler/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");
/*! fromentries. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */
module.exports = function fromEntries(iterable) {
  return _toConsumableArray(iterable).reduce(function (obj, _ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      val = _ref2[1];
    obj[key] = val;
    return obj;
  }, {});
};